module.exports = __webpack_public_path__ + "static/img/h5.e4b9af6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/h5.png
// module id = iC6b
// module chunks = 1